// ==============================|| DEFAULT THEME - SHAPE ||============================== //

const CustomShapes = (theme) => ({
  borderRadius: 8,
  borderRadiusLarge: '14px',
});

export default CustomShapes;
